<template>
  <v-app>
    <v-container class="pa-0 ma-0">
      <v-overlay :value="true" opacity="1" z-index="200" color="primary">
        <CsPhoneVerification
          :api-base-url="apiBaseUrl"
          :token="token"
          :language="currentLocale"
          :logo="logoComponent"
          @set-company="handleSetCompany"
        />
      </v-overlay>
    </v-container>
  </v-app>
</template>
<script>
import { CsPhoneVerification } from "@conecta-suite/vue2-components";
import { mapGetters, mapMutations } from "vuex";
import Logo from "@/components/base/Logo.vue";

export default {
  name: "PhoneVerificationFlow",
  components: {
    CsPhoneVerification,
  },
  computed: {
    ...mapGetters(["token", "currentUser"]),
    apiBaseUrl() {
      return process.env.VUE_APP_API_BASE_URL;
    },
    currentLocale() {
      return this.$i18n.locale;
    },
    logoComponent() {
      return Logo;
    },
  },
  methods: {
    ...mapMutations(["setCompany", "setCurrentUser"]),

    handleSetCompany(company) {
      this.setCompany(company);
      this.$router.push({ name: "Home" });
    },
  },
};
</script>
